import React, {useState} from 'react'
import Button from '@components/Button'

import styles from './styles.module.css'

export default function CopyBox(props) {
  const {value, onChange, buttonContent, onClick} = props
  const [focused, setFocused] = useState(false)
  const valueIsEmail = value && value.includes('@') && value.includes('.')

  return (
    <div className={styles.container}>
      <div className="os-input-container">
        <div className={focused ? styles.boxFocused : styles.box}>
          <input
            className={styles.input}
            type="email"
            placeholder="Ingresa tu email"
            value={value}
            onChange={event => onChange(event.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            autoComplete="email"
          />
          <div className={styles.buttonContainer}>
            <Button primary onClick={onClick} disabled={!valueIsEmail}>
              {buttonContent}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
